import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-demo-information',
  templateUrl: './dialog-demo-information.component.html',
  styles:  [' .mat-dialog-actions {justify-content: flex-end;} ']
})
export class DialogDemoInformationComponent  {
}
